/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ServerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB1UlEQVR4nN2Uv2sUURDHT6NgEdDGNKKoGP8FQYxXJnA3850LTGYuCAcpDtJZBAISOMQqopWVnU26gNolEkiI+ANrScpAihBiI6QIIcHI27vLibe39+600YWB3eU783kz7/teLvffPoXx8jDDP5H4OmDXs7SqOgBMjDLsFYt9JbHpzOJAmQj+ncVP6mHfilK+95vsDGB3Gf6CxXZbWj8h+H5q4Vqtdpbgj1n8x68JXI+5OrxyiWBPSHwrRXMaqQAWW+yUQKS3Eg3sXVbhjoB8Pn8uK0FVB4KO4Md9AarV6vmYBI4o3h0AOyjCZsZUL5dKD4bC+18DEGyH2e+kblLuDwDBdiz+ErCr4aMwPnmT4V9CEOmNpojEPvcLaK2SJ+4H77dG5nuAjSRmqFQukPhC3wAWnyL4YZtNkfybanZLsNkO5yUdEGxI8Ofd27dnTcsCNsniR10BqjpIYm9jN5DEllT1YqPjua4Ahn2MLc6nEP+QmKGgVyIAvtwrgMVXQm6xqNei9oDgG9HFYZutPHsUBWDY+x7Gsx5yROx21CY3xvQmfjz2un5evBRtU4I/7QEwn+SITXfocLsNEC42hq1lXccEPybx1aBtLOphWnEq+Vgb4J99fgIiVHm8Mt4ZAwAAAABJRU5ErkJggg==)
 */
export const ServerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.55 4.4c.13-.24.1-.54-.12-.71L8.6 2.24a1 1 0 0 0-1.24 0l-4 3.15a1 1 0 0 0-.38.79v4.03c0 .43.5.66.82.39l2.28-1.9a3 3 0 0 1 3.84 0c.03.02.08 0 .08-.04V6.42a4 4 0 0 1 .55-2.02ZM7.36 10.23a1 1 0 0 1 1.28 0l1.18.99 2.98 2.48 1.84 1.53a1 1 0 0 1-.67 1.77.1.1 0 0 0-.1.09l-.23 3.06a2 2 0 0 1-2 1.85H4.36a2 2 0 0 1-2-1.85l-.24-3.16a1 1 0 0 1-.76-1.76l6-5Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 10.2c0 .14.07.28.18.38l3.74 3.12a3 3 0 0 1 .03 4.58.55.55 0 0 0-.2.37l-.12 1.65a4 4 0 0 1-.17.9c-.12.38.13.8.52.8H20a2 2 0 0 0 2-2V3.61a1.5 1.5 0 0 0-2-1.41l-6.66 2.33A2 2 0 0 0 12 6.42"
        className={colorClass}
      />
    </svg>
  );
};
